jQuery(function($){
  $('.prizes-listing').each(function(){
    $('div.prize-teaser .prize-teaser__header').on('click', function() {
      $(this).parent().toggleClass('is-opened');
    });
  });
});
